module.exports = __webpack_public_path__ + "static/media/logoloading.3e27a28f.gif";